<script lang="typescript">
  import type { User } from "../../common/types";
  export let users:Array<User>;
  $:supervisors = users
    .filter( u => u.is_supervisor )
    .sort((a, b) => a.id - b.id );
</script>

<div>
  <table>
    <thead>
      <tr>
        <th>Id</th>
        <th>Nimi</th>
        <th>
          Käyttäjätunnus
        </th>
        <th>
          Osaston nimi tuotteissa
        </th>
    </thead>
    <tbody>
      {#each supervisors as supervisor}
        <tr>
          <td>
            {supervisor.id}
          </td>
          <td>
            {supervisor.name}
          </td>
          <td>
            {supervisor.login}
          </td>
          <td>
            {supervisor.supervisor_slug}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  table, th, td {
    border: 1px solid black;
  }
  table {
    border-collapse: collapse;
  }

  th, td {
    padding: 6px;
  }
</style>

